import { jsx as _jsx } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2026-01-31 22:57:43 +0100 (Sat, 31 Jan 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 160223 $
//  Purpose   : parts for templating system
// =============================================================================
// ---Third-party imports
import React from 'react';
// ---Framework imports
import { funcPart, loadLazy } from 'uix/parts';
// ---Exports
const PartThemeBuilder = loadLazy(()=>import(/* webpackChunkName: 'admin' */ './theming'));
export const ThemeBuilder = funcPart({
    partStyle: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column'
    }
}, (props)=>/*#__PURE__*/ _jsx(PartThemeBuilder, {
        ...props
    }));
export const InspectViews = loadLazy(()=>import(/* webpackChunkName: 'admin' */ './inspectviews'));
